import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCFishGuard extends NPC {
    constructor() {
        super(definitions.NPC_ID.FISH_GUARD);

        this.collisionRadius = 26;
        this.collisionOffsetX = -7;
        this.collisionOffsetY = -26;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_fish_guard_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.7, new PIXI.Point(-7, -10));
        this.animateIdle(0.6);
    }
}